import { render, staticRenderFns } from "./IndividualReport.vue?vue&type=template&id=775b2cb2"
import script from "./IndividualReport.vue?vue&type=script&lang=js"
export * from "./IndividualReport.vue?vue&type=script&lang=js"
import style0 from "./IndividualReport.vue?vue&type=style&index=0&id=775b2cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports